module.exports = __webpack_public_path__ + "img/gotop.3cb5966f.png";